export default __webpack_public_path__ + "static/media/file_filled.208129c8.svg";